<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path d="M21.7,19.41A12.24,12.24,0,0,0,19.56,2.68,12,12,0,0,0,2.64,4.55,12.25,12.25,0,0,0,4.5,21.64a11.94,11.94,0,0,0,15.07,0L29.83,32,32,29.81ZM21,12.2a9,9,0,1,1-9-9.06A9,9,0,0,1,21,12.2Z" />
</svg>
